<template lang="html">
  <div class="ui-store-wrapper">
    <div class="ui-store-choose chooseHover">
      <ul class="ui-store-choose-select">
        <li
          class="ui-store-choose-select-item"
          v-for="(item, index) in storeList"
          :class="{ hover: item.selected }"
          @click="getAll(item, index, $event)"
        >
          {{ item.store_desc }}
        </li>
      </ul>
    </div>
    <!-- <div class="ui-button"><button class="ui-reset-select" v-if="needRestBt" @click="reset">重置</button><button class="ui-comfrim-select" @click="submit">确定</button></div> -->
  </div>
</template>

<script>
import config from '@/plugins/config'
import utils from '@/plugins/utils'
import jsCookie from 'js-cookie'
import fetch from '@/plugins/fetch'
import queryString from 'query-string'

export default {
  props: {
    selectedId: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    cityCode: {
      type: [String, Number],
      default: ''
    },
    needRestBt: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // toast
  },
  data() {
    return {
      api: '',
      show: 0,
      storeList: []
    }
  },
  computed: {},
  methods: {
    hostname(prefix = '') {
      const hn = location.hostname
      return hn.indexOf('haiziwang.com') > -1
        ? `//${prefix}.haiziwang.com`
        : `//${prefix}.cekid.com`
    },
    scrollToHover() {
      this.$nextTick(() => {
        const el = document.querySelector('.chooseHover .hover')
        if (el) {
          const offsetTop = el.offsetTop
          document.querySelector('.chooseHover').scrollTop = offsetTop
        }
      })
    },
    getAll(item, index, $e) {
      item.selected = !item.selected
      this.$set(this.storeList, index, item)
      this.$emit('input', item)
    },
    reset() {
      this.storeList.forEach((v, i) => {
        v.selected = false
        this.$set(this.storeList, i, v)
      })
    },
    submit() {
      const selectedList = this.storeList.filter(v => v.selected)
      this.$emit('input', selectedList)
    },
    init() {
      this.getStoreList()
    }
  },
  async created() {
    this.api = {
      storeList: `${utils.hostname(
        'activity'
      )}/activity/storeO2O/queryStoreList.do`
    }
    try {
      const results_res = await fetch(
        `${this.api.storeList}?city_code=${this.cityCode}`
      )
      const results_json = await results_res.json()
      if (results_json.data.length > 0) {
        const results = results_json.data
        results.forEach(v => {
          v.selected = false
          if (this.selectedId.includes(v.store_code)) {
            v.selected = true
          }
        })
        this.storeList = results
        // this.$set(this.storeList, 0, results)
      } else {
        this.$$toast('抱歉，系统异常')
      }
    } catch (e) {
      console.log(e)
      this.$$toast('抱歉，系统异常')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.ui-store-wrapper {
  position: relative;
  height: 100%;
}
.ui-store-choose {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  // overflow-x: hidden;
  // overflow-y: auto;
  background-color: #fff;
  -webkit-overflow-scrolling: touch;

  .ui-store-choose-select {
    // margin-bottom: rem(90px);
    .ui-store-choose-select-item {
      margin-left: rem(25px);
      font-size: rem(30px);
      line-height: rem(80px);
      position: relative;
      @include border(bottom);
      &.hover {
        color: #ff397e;

        &:before {
          font-family: iconfont !important;
          font-size: 28px;
          line-height: 45px;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
          -webkit-text-stroke-width: 0.2px;
          display: block;
          // color: rgba(0,0,0,.5);
          color: #ff397e;
          content: '\e6e1';
          position: absolute;
          right: 15px;
          top: 50%;
          margin-top: -22px;
          margin-right: -10px;
        }
      }
    }

    .selected:after {
      font-family: iconfont !important;
      font-size: 16px;
      line-height: 45px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -webkit-text-stroke-width: 0.2px;
      display: block;
      // color: rgba(0,0,0,.5);
      color: #ff397e;
      content: '\e6e1';
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -22px;
      margin-right: -10px;
    }
  }

  &.chooseHover {
    display: block;
  }
  &.title-hide {
    top: 0;
  }
}
.ui-store-choose-group {
  display: flex;
  font-size: rem(30px);
  line-height: rem(80px);
  text-align: center;
  .ui-store-choose-group-item {
    @include border(bottom);
    flex: 1;
    &.hover {
      color: #ff397e;
      &::before {
        border-bottom: 1px solid #ff397e;
      }
    }
  }
}
.ui-button {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: rem(80px);
  // text-align: center;
  z-index: 99;
}
.ui-reset-select {
  background-color: #fff;
  color: #ff397e;
  width: 100%;
  height: rem(80px);
  @include border(top);
}
.ui-comfrim-select {
  background-color: #ff397e;
  width: 100%;
  color: #fff;
  height: rem(80px);
}
</style>
